export default "__VITE_ASSET__e0cac23c__"